import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  Table,
  I18n,
} from 'components';

import {
  formatDateString,
  formatPrice,
} from 'utils/formatString';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const PaymentsDetailsTable = ({
  data,
  overpayment,
}) => {
  if (!data) {
    return null;
  }

  return (
    <div className={cx('component')}>
      <div className={cx('arrow')} />
      <div className={cx('content')}>
        <Table
          data={data}
          config={{
            columns: [
              {
                name: 'detalization.payments.invoiceNumber',
                dataField: 'invoiceNumber',
              },
              {
                name: 'detalization.payments.benNumber',
                dataField: 'benNumber',
              },
              {
                name: 'detalization.payments.dueDate',
                dataField: 'dueDate',
                transformer: ({ dueDate }) => formatDateString(dueDate, 'DD.MM.YYYY'),
              },
              {
                name: 'detalization.payments.totalAmount',
                dataField: 'amount',
                transformer: ({ amount = 0 }) => `${formatPrice(amount)} ₽`,
              },
              {
                name: 'detalization.payments.paymentValue',
                dataField: 'paymentValue',
                transformer: ({ paymentValue = 0 }) => `${formatPrice(paymentValue)} ₽`,
              },
              {
                name: 'detalization.payments.unpaidAmount',
                dataField: 'unpaidAmount',
                transformer: ({ unpaidAmount = 0 }) => `${formatPrice(unpaidAmount)} ₽`,
              },
              {
                name: 'detalization.payments.billStatus',
                dataField: 'status',
              },
            ],
            uniqueIdField: 'invoiceNumber',
          }}
        />
        {overpayment && overpayment > 0 && (
          <div className={cx('footer')}>
            <div className={cx('overpayment')}>
              <I18n path="detalization.payments.overpayment" />
              <br />
              {formatPrice(overpayment)}
              {' '}
              ₽
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

PaymentsDetailsTable.propTypes = {
  data: PropTypes.array,
  overpayment: PropTypes.number,
};

export default PaymentsDetailsTable;
